<div class="page-wrapper">
  <section class="white email-verified-section">
    <div class="content-wrapper email-verified-content-wrapper">
      <h1 class="email-verified-title">Confirm your email address</h1>
      <p>Click below to confirm your email address.</p>

      <a *ngIf="verifyUrl" [attr.href]="verifyUrl">
        <button class="button">Confirm your email address</button>
      </a>
    </div>
  </section>
</div>
